"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./ViewerTable.css");
const mithril_1 = __importDefault(require("mithril"));
const stream_1 = __importDefault(require("mithril/stream"));
const lodash_1 = __importDefault(require("lodash"));
const shared_1 = require("../shared");
require("../Act");
const ViewerTableRow_1 = __importDefault(require("./ViewerTableRow"));
const export_1 = require("../export");
const ViewerTable = ({ attrs: { acts$, filterFromTable$, selectedActId$, hoveredActIds$, visibleActs$ } }) => {
    let headerDom;
    let headerOpen = true;
    let mouseIsHovering = false;
    const typeFilter$ = (0, stream_1.default)('All');
    const nameFilter$ = (0, stream_1.default)(undefined);
    const sort$ = (0, stream_1.default)({ column: 'date', dir: 'desc' });
    const columnToDataPath = {
        date: 'data.start_date',
        time: 'data.moving_time',
        distance: 'data.distance',
        elevation: 'data.total_elevation_gain',
    };
    // TODO: Kinda strange structure we have going here
    stream_1.default.lift((typeFilter, nameFilter) => {
        const nameFilterLowerPieces = nameFilter ? nameFilter.toLowerCase().split(' ') : undefined;
        filterFromTable$(act => {
            if (typeFilter !== 'All' && act.data.type !== typeFilter) {
                return false;
            }
            if (nameFilterLowerPieces) {
                const nameLower = act.data.name.toLowerCase();
                if (!nameFilterLowerPieces.every(piece => nameLower.includes(piece))) {
                    return false;
                }
            }
            return true;
        });
    }, typeFilter$, nameFilter$);
    const sortedActs$ = stream_1.default.lift((acts, sort) => {
        return lodash_1.default.orderBy(acts, columnToDataPath[sort.column], sort.dir);
    }, acts$, sort$);
    function toggleSort(toggleColumn) {
        const { column, dir } = sort$();
        if (column === toggleColumn) {
            sort$({ column, dir: dir === 'asc' ? 'desc' : 'asc' });
        }
        else {
            sort$({ column: toggleColumn, dir: 'desc' });
        }
    }
    function oncreateScroller({ dom }) {
        // when a new activity is selected, scroll to it in the table
        selectedActId$.map((selectedActId) => {
            if (!selectedActId) {
                return;
            }
            let tableRow = document.getElementById(`ViewerTableRow-${selectedActId}`);
            if (!tableRow) {
                console.warn("cannot find table row for ", selectedActId);
                return;
            }
            const tableScrollerRect = dom.getBoundingClientRect();
            const tableRowRect = tableRow.getBoundingClientRect();
            if (tableRowRect.top >= tableScrollerRect.top && tableRowRect.bottom <= tableScrollerRect.bottom) {
                return;
            }
            tableRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
    }
    function columnLabel(column) {
        const { column: sortColumn, dir: sortDir } = sort$();
        return (0, mithril_1.default)('.ViewerTable-column-label', {
            class: sortColumn === column ? 'ViewerTable-column-label-' + sortDir : undefined,
            onclick: () => toggleSort(column),
        }, column);
    }
    (0, shared_1.redrawOn)(hoveredActIds$, selectedActId$, sort$);
    return {
        view: () => {
            const types = lodash_1.default.chain(acts$())
                .groupBy('data.type')
                .toPairs()
                .orderBy(([_type, actsOfType]) => actsOfType.length, 'desc')
                .map(([type, _actsOfType]) => type)
                .value();
            const typeOptions = ['All', ...types];
            return (0, mithril_1.default)('.ViewerTable', (0, mithril_1.default)('.ViewerTable-header', {
                class: headerOpen ? 'ViewerTable-header-open' : 'ViewerTable-header-closed',
                style: {
                    height: headerDom && `${headerOpen ? headerDom.scrollHeight : 0}px`,
                    top: headerDom && `${headerOpen ? 0 : -headerDom.scrollHeight}px`,
                },
                oncreate: ({ dom }) => headerDom = dom,
            }, (0, mithril_1.default)('.ViewerTable-fake-row.ViewerTableRow', (0, mithril_1.default)('.ViewerTableRow-left', (0, mithril_1.default)('select.ViewerTableRow-type-selector', {
                value: typeFilter$(),
                onchange: (ev) => typeFilter$(typeOptions[ev.target.selectedIndex]),
            }, typeOptions.map(typeOption => (0, mithril_1.default)('option', typeOption)))), (0, mithril_1.default)('.ViewerTableRow-right', (0, mithril_1.default)('.ViewerTableRow-name', (0, mithril_1.default)('.ViewerTable-name-filter-container', (0, mithril_1.default)('input.ViewerTable-name-filter', {
                value: nameFilter$(),
                oninput: (ev) => nameFilter$(ev.target.value),
                placeholder: 'Activity name',
            }), nameFilter$() && ((0, mithril_1.default)('.ViewerTable-name-filter-clear', {
                onclick: () => nameFilter$(undefined),
            })))), (0, mithril_1.default)('.ViewerTableRow-date', columnLabel('date')), (0, mithril_1.default)('.ViewerTableRow-stat', columnLabel('time')), (0, mithril_1.default)('.ViewerTableRow-stat', columnLabel('distance')), (0, mithril_1.default)('.ViewerTableRow-stat', columnLabel('elevation')))), (0, mithril_1.default)('select.ViewerTable-header-download-selector', {
                value: '⤓',
                onchange: (ev) => {
                    const format = ev.target.value;
                    ev.target.value = '⤓';
                    const acts = visibleActs$();
                    if (acts.length === 0) {
                        return;
                    }
                    let contents;
                    if (format === 'json') {
                        contents = JSON.stringify((0, export_1.actsToGeoJSON)(acts), null, 2);
                    }
                    else if (format === 'gpx') {
                        contents = (0, export_1.actsToGPX)(acts);
                    }
                    else if (format === 'kml') {
                        contents = (0, export_1.actsToKML)(acts);
                    }
                    else {
                        console.warn("unknown format: ", format);
                        return;
                    }
                    (0, export_1.saveFile)(new Blob([contents], { type: 'text/plain' }), `activities.${format}`);
                },
            }, (0, mithril_1.default)('option', { disabled: true }, '⤓'), (0, mithril_1.default)('option', { disabled: true }, 'Download'), (0, mithril_1.default)('option', { value: 'json' }, '... as GeoJSON'), (0, mithril_1.default)('option', { value: 'gpx' }, '... as GPX'), (0, mithril_1.default)('option', { value: 'kml' }, '... as KML'))), (0, mithril_1.default)('.ViewerTable-scroller', { oncreate: oncreateScroller }, (0, mithril_1.default)('.ViewerTable-acts', sortedActs$().map((act) => (0, mithril_1.default)(ViewerTableRow_1.default, {
                act,
                isVisible: visibleActs$().includes(act),
                isHovered: hoveredActIds$().includes(act.data.id),
                isHoveredDirectly: hoveredActIds$().includes(act.data.id) && mouseIsHovering,
                isSelected: act.data.id === selectedActId$(),
                attrs: {
                    onmouseover: () => { mouseIsHovering = true; hoveredActIds$([act.data.id]); },
                    onmouseout: () => { mouseIsHovering = false; hoveredActIds$([]); },
                    onclick: () => (0, shared_1.toggle)(selectedActId$, act.data.id),
                },
            })))), typeFilter$() === 'All' && !nameFilter$() && ((0, mithril_1.default)('.ViewerTable-header-toggle', {
                class: headerOpen ? 'ViewerTable-header-toggle-close' : 'ViewerTable-header-toggle-open',
                onclick: () => { headerOpen = !headerOpen; },
            })));
        },
    };
};
exports.default = ViewerTable;
